import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';

export const serviceButtonStyleOverride: SxStyles = {
  borderColor: NeutralColors.light_neutrals_300,
  borderRadius: '12px',
};
